import { formatDateTimeFromMillis } from '@/filter/date';
import { formatMitarbeiterFullName } from '@/filter/mitarbeiter';

export const artikelnummer = {
  key: 'artikelnummer',
  sortable: true,
  label: 'Artikelnummer',
  sortKey: 'artikelnummer',
};

export const artikelname = {
  key: 'artikelname',
  sortable: true,
  label: 'Artikel',
  sortKey: 'artikelname',
};

export const protokoll = {
  key: 'protokoll',
  sortable: true,
  label: 'WEP',
  sortKey: 'wp.name',
  formatter: (value) => value?.name || '',
};

export const createdAt = {
  key: 'created_at',
  sortable: true,
  label: 'Erstellt am',
  sortKey: 'created_at',
  formatter: (value) => formatDateTimeFromMillis(value),
};

export const createdFrom = {
  key: 'created_from',
  label: 'Erstellt von',
  formatter: (value) => formatMitarbeiterFullName(value),
};

export const finishedAt = {
  key: 'finished_at',
  sortable: true,
  label: 'Fertiggestellt am',
  sortKey: 'finished_at',
  formatter: (value) => formatDateTimeFromMillis(value),
};

export const finishedFrom = {
  key: 'finished_from',
  label: 'Fertiggestellt von',
  formatter: (value) => formatMitarbeiterFullName(value),
};

export const warenannahme = {
  key: 'warenannahme',
  sortable: true,
  label: 'Warenannahme',
  sortKey: 'warenannahme',
  tdClass: 'text-center',
  formatter: (value) => (value ? 'Ja' : 'Nein'),
};

export const reason = {
  key: 'finished_reason',
  sortable: true,
  label: 'Grund',
  sortKey: 'finished_reason',
};

export const pruefungStatus = {
  key: 'pruefung_status',
  sortable: false,
  label: 'Prüfungen',
  tdClass: 'text-center',
};

export default [
  artikelnummer,
  artikelname,
  protokoll,
  createdAt,
  createdFrom,
  finishedAt,
  finishedFrom,
  warenannahme,
  reason,
];
